import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ShopItemTypeList').create(() => ({
  root: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '16px',
  },

  specialOfferItems: {
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: 'repeat(3, 1fr)',
    width: '100%',
    position: 'relative',
  },
  regularOfferItems: {
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: 'repeat(3, 1fr)',
    width: '100%',
  },

  regularItemsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    h1: {
      textAlign: 'left',
      fontWeight: 450,
      color: 'white',
      fontSize: '18px',
    },
  },

  glow: {
    position: 'absolute',
    background: '#FF8000',
    width: '40%',
    height: '40%',
    filter: 'blur(90px)',
    bottom: '40%',
  },
}))
